import { z } from "zod"

import { type PermissionRole } from "@/constants/permissions"
import { type AuthTokens } from "@/graphql/codegen/graphql"

export const idTokenSchema = z.object({
  id_token: z.string().min(1, "ID token is required"),
})

export type IdTokenPayload = z.infer<typeof idTokenSchema>

export interface TokenUser {
  id: string
  fullName: string
  oldId: string
  role: PermissionRole
  email: string
  isActive: boolean
  avatarUrl?: string
}

export interface DecodedIdToken {
  "cognito:username": string
  "custom:as400_id": string
  "custom:user_role": string
  "custom:Role": PermissionRole
  "custom:avatar_url": string
  name: string
  email: string
}

export interface DecodedAccessToken {
  isActive: boolean
}

export type UserAuthStatus = "idle" | "loading" | "authenticated" | "unauthenticated"

export interface Tokens extends Partial<Pick<AuthTokens, "accessToken" | "refreshToken">> {
  idToken?: string
}
